import numeral from 'numeral'
numeral.register('locale', 'th', {
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function (number) {
    return number === 1 ? 'er' : 'ème'
  },
  currency: {
    symbol: 'THB'
  }
})
numeral.locale('th')



// WEBPACK FOOTER //
// ./src/plugins/numeral.js